"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NotificationCounter;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _Text = _interopRequireDefault(require("./Text"));
var _styles = require("@sart/styles");
var _excluded = ["count", "style", "textStyle"];
function NotificationCounter(props) {
  var count = props.count,
    style = props.style,
    textStyle = props.textStyle,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var containerStyle = [styles.container, style];
  var textStyles = [styles.text, textStyle];
  if (!(count > 0)) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, (0, _extends2["default"])({
    style: containerStyle
  }, rest), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: textStyles
  }, count));
}
var styles = _reactNative.StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 18,
    minHeight: 18,
    backgroundColor: _styles.colors.alert,
    borderRadius: 18 / 2
  },
  text: {
    fontSize: 12,
    lineHeight: 12,
    fontWeight: '700',
    textAlign: 'center',
    color: _styles.colors.clear,
    paddingHorizontal: 5,
    paddingVertical: 3
  }
});